import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import FilterTable from 'ntnu-react/material/FilterTable';
import RaisedButton from 'material-ui/RaisedButton';

import {
    getProposalList,
} from '../actions/proposalAction';

const defaultColumns = [
    { key: 'title', fieldName: 'Title', name: 'Tittel'},
    { key: 'author', fieldName: 'Author', name: 'Innsender'},
    { key: 'averagescore', fieldName: 'AverageScore', name: 'Prioritering'},
    { key: 'required', fieldName: 'Required1', name: 'Pålagt'},
    { key: 'created', fieldName: 'Created', name: 'Dato innmeldt'},
    { key: 'status', fieldName: 'Status1', name: 'Status'},
    { key: 'portefolio', fieldName: 'Endringsportefolje', name: 'Endringsportefølje'},
    { key: 'modified', fieldName: 'Modified', name: 'Endret'},
];

class CompletedPage extends React.Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        router: PropTypes.object.isRequired,
        proposals: PropTypes.array.isRequired,
    }

    state = {
        selected: undefined,
        items: [],
        columns: defaultColumns.map((col) => {
            return {...col};
        }),
    }

    componentDidMount() {
        this.props.dispatch(getProposalList());
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            items: nextProps.proposals.filter((item) => {
                return item.statusCode === '4';
            }),
        });
    }

    handleView = () => {
        this.props.router.push(`/view/${this.state.selected.Id}`);
    }

    handleSelect = (selected) => {
        if (selected !== this.state.selected) {
            this.setState({selected});
        }
    }

    render() {
        const { selected, items } = this.state;

        return (
            <section>
                <h2>Fullførte forslag</h2>
                <FilterTable
                    columns={this.state.columns}
                    items={items}
                    onSelect={this.handleSelect}
                    defaultSortBy={4}
                    defaultDesc={true}
                />
                <div style={{marginTop: '1rem'}}>
                    <RaisedButton
                        label='Se på'
                        onClick={this.handleView}
                        disabled={!selected}
                        style={{marginRight: '.5rem'}}
                    />
                </div>
            </section>
        );
    }
}

function mapStateToProps(state) {
    return {
        proposals: state.proposalData.proposalList,
    };
}

export default connect(mapStateToProps)(CompletedPage);



// WEBPACK FOOTER //
// ./src/containers/CompletedPage.js